import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = []

  connect() {
    setTimeout(this.checkReceipts.bind(this), 5000)
  }

  checkReceipts() {
    this.element.src = this.element.getAttribute('data-timeout-src')
  }
}
